import { toast } from "@/components/ui/use-toast";
import axios, { HttpStatusCode } from "axios";
import { defaultHeader } from "../constants/defaultItems";
export const getBannerList = (callback) => (dispatch) => {
  axios
    .get("/api/OfferBanner/GetBannerList", defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        callback && callback(resp.data.Result);
      }
    })
    .catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message,
      });
    });
};

export const GetInfoById = (bannerId) => (dispatch) => {
  axios.get(`/api/OfferBanner/GetInfoById?bannerID=${bannerId}`, defaultHeader).then((response) => {
    if (response.data.IsSuccess) {
      let result = response.data.Result;
      setSiteSEO(result.Title, result.Description, result.ImageUrl);
    }
  });
}